import { useHoleFootprint } from '../../hooks/useHoleFootprint';
import { Hole } from '@slope/three';
import { useMemo } from 'react';
import { Typography } from '@slope/uikit';

export type GreenFootprintProps = {
  hole: Hole;
};

const GreenFootprint: React.FC<GreenFootprintProps> = ({ hole }) => {
  const getHoleFootprint = useHoleFootprint();

  const imgSrc = useMemo(() => getHoleFootprint(hole), [getHoleFootprint, hole]);

  return (
    <img
      src={imgSrc}
      alt="Hole Footprint"
      style={{ width: 'auto', height: 'auto', maxHeight: '140px' }}
    />
  );
};

export type GreenInfoProps = {
  hole: Hole;
};

export const GreenInfo: React.FC<GreenInfoProps> = ({ hole }) => {
  return (
    <div
      style={{
        width: '140px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
      }}
    >
      {<GreenFootprint hole={hole} />}
      <Typography fontSize="1.2rem">5F 10D</Typography>
    </div>
  );
};
